/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { Container, Table } from "./styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Services
import { 
    requestGetUserPerRole, 
    requestGetPermissionsByUserId } from "services/auth/users";
import { currentUserLocalStorage } from "services/storage/general";
import { getToken } from "services/auth/tokenAuth";
import Preloader from "components/Preloader/Preloader";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import { IS_PRODUCTION } from "config/deploymentMode";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
//#endregion

const UsersPerRole = () => {
    const navigate = useNavigate();
    //#region States
    const [users, setUsers] = useState([]);
    const [readyView, setReadyView] = useState(false);
    //#endregion
    const loadingRequest = useLoadingRequest();
    //#region Effects
    useEffect(() => {
        //#region Validando previo logueo
        if (!getToken()) {
            navigate("/login");
            return;
        }
        if (IS_PRODUCTION) {
            navigate(ABSOLUTE_PATHS.HOME);
            return;
        }
        setReadyView(true);
        //#endregion
        fillUsers();
    }, []);
    //#endregion
    //#region Functions
    const fillUsers = async () => {
        loadingRequest.show();
        const fetchUsers = await requestGetUserPerRole();
        loadingRequest.hide();
        setUsers(fetchUsers);
    }
    const startTest = async usertForTest => {
        loadingRequest.show("Iniciando test...");
        const { user, modules } = await requestGetPermissionsByUserId(usertForTest.id);
        loadingRequest.hide();
        currentUserLocalStorage.set({
            ...user,
            id: usertForTest.id,
            modules
        });
        navigate(ABSOLUTE_PATHS.HOME);
    }
    //#endregion
    if (!readyView) 
        return null;
    return (
        <>
        <Preloader {...loadingRequest.value}/>
        {users.length > 0 &&
        <Container>
            <Table>
                <thead>
                    <tr>
                        <th>USUARIO</th>
                        <th>ROL</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, idx) => {
                        const { name, role } = user;
                        return (
                            <tr key={idx}>
                                <td>{name}</td>
                                <td>{role}</td>
                                <td>
                                    <CustomButton 
                                        text="Test"
                                        variant="quaternary"
                                        onClick={() => startTest(user)}/>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </Container>}
        </>
    );
}

export default UsersPerRole;